import type { OrganizationLLMResolvedConfig } from "./api/runtimeTypes"
import type { StandaloneSetupStatus } from "./api/standaloneSetup"

export type AgentAccessMode = "hosted" | "byok"

const ACCESS_MODE_STORAGE_KEY = "agent-os.access-mode"

export function isHostedRuntimeConfigured(status?: StandaloneSetupStatus | null): boolean {
  return Boolean(status?.hostedConfigured)
}

export function isAgentMauriceResolvedConfig(
  config?: OrganizationLLMResolvedConfig | null,
): boolean {
  return config?.provider_family === "agentmaurice"
}

export function inferAccessModeFromServer(
  status?: StandaloneSetupStatus | null,
  resolvedConfig?: OrganizationLLMResolvedConfig | null,
): AgentAccessMode | null {
  if (isAgentMauriceResolvedConfig(resolvedConfig)) {
    return "hosted"
  }

  if (resolvedConfig) {
    return "byok"
  }

  if (status?.configured && isHostedRuntimeConfigured(status)) {
    return "hosted"
  }

  if (status?.configured) {
    return "byok"
  }

  return null
}

export function getStoredAccessMode(): AgentAccessMode | null {
  if (typeof window === "undefined") {
    return null
  }

  const storedMode = window.localStorage.getItem(ACCESS_MODE_STORAGE_KEY)
  return storedMode === "hosted" || storedMode === "byok" ? storedMode : null
}

export function setStoredAccessMode(mode: AgentAccessMode | null): void {
  if (typeof window === "undefined") {
    return
  }

  if (!mode) {
    window.localStorage.removeItem(ACCESS_MODE_STORAGE_KEY)
    return
  }

  window.localStorage.setItem(ACCESS_MODE_STORAGE_KEY, mode)
}
